module.exports = "#ifdef USE_MODEL_FADING\nuniform vec3 origoFading;\nuniform float startFading;\nuniform float endFading;\n#endif\n";